import Vue from 'vue'

export const eventhub = new Vue()
export const EVENT_ACCOUNT_ISLOGGEDIN='account:isLoggedIn'
export const EVENT_CART_TIMECHANGED='cart:timechanged'
export const EVENT_CART_CREATED='cart:created'
export const EVENT_SHOP_INITIALIZED='shop:initialized'

export default eventhub